"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductItemValueRadios = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _tableContext = require("../../productsTable/stateHelpers/tableContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ProductItemValueRadios = exports.ProductItemValueRadios = function ProductItemValueRadios(_ref) {
  var labelKey = _ref.labelKey,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    planNumber = _ref.planNumber,
    value = _ref.value,
    values = _ref.values,
    _ref$valueMap = _ref.valueMap,
    valueMap = _ref$valueMap === void 0 ? {
      label: 'label',
      value: 'value'
    } : _ref$valueMap,
    defaultValue = _ref.defaultValue,
    defaultValueIndex = _ref.defaultValueIndex,
    formatters = _ref.formatters,
    formContext = _ref.formContext,
    _ref$onRadioSelect = _ref.onRadioSelect,
    onRadioSelect = _ref$onRadioSelect === void 0 ? function () {} : _ref$onRadioSelect;
  var _useContext = (0, _react.useContext)(_tableContext.TableContext),
    petIndex = _useContext.tableContext.petIndex;
  var hookFormContext = (0, _reactHookForm.useFormContext)();
  var radioFormContext = formContext || hookFormContext;
  var checkedValue = value || defaultValue || valueMap.value && values[defaultValueIndex] && values[defaultValueIndex][valueMap.value] || values[defaultValueIndex];
  var formattedCheckedValue = formatters && formatters.value ? formatters.value(checkedValue) : "".concat(checkedValue);
  var radioProps = {
    groupName: "pet_".concat(petIndex, "_plan_").concat(planNumber, "_").concat(labelKey, "_radios"),
    name: "pet_".concat(petIndex, "_plan_").concat(planNumber, "_").concat(labelKey, "_radios"),
    groupLabel: "Choose your ".concat(label),
    hideGroupLabel: true,
    disabled: disabled,
    radioInputs: values.map(function (value, index) {
      return {
        disabled: disabled,
        labelCssClass: {
          checked: 'button labelText valueYesNoChecked',
          unchecked: 'button labelText valueYesNo'
        },
        label: formatters && formatters.label ? formatters.label(value[valueMap.label]) : "".concat(value[valueMap.label]),
        value: formatters && formatters.value ? formatters.value(value[valueMap.value]) : "".concat(value[valueMap.value])
      };
    }),
    onChange: onRadioSelect,
    value: formattedCheckedValue
  };
  return /*#__PURE__*/_react["default"].createElement(_components.StyledRadios, _extends({}, radioProps, {
    fieldFormContext: radioFormContext
  }));
};
ProductItemValueRadios.propTypes = {
  labelKey: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].element]),
  planNumber: _propTypes["default"].number,
  disabled: _propTypes["default"].bool,
  /* eslint-disable-next-line react/forbid-prop-types */
  values: _propTypes["default"].any,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].number]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].number]),
  defaultValueIndex: _propTypes["default"].number,
  valueMap: _propTypes["default"].shape({
    label: _propTypes["default"].string,
    value: _propTypes["default"].string
  }),
  formatters: _propTypes["default"].shape({
    label: _propTypes["default"].func,
    value: _propTypes["default"].func
  }),
  /* eslint-disable-next-line react/forbid-prop-types */
  formContext: _propTypes["default"].any,
  onRadioSelect: _propTypes["default"].func
};
var _default = exports["default"] = {
  ProductItemValueRadios: ProductItemValueRadios
};